module.exports = __webpack_public_path__ + "static/media/PowerApps.0787cccb.svg";